import React from 'react';
import Header from '../header/Header';
import { SMessageSubtitle, SMessageBody } from './styled/SResultMessage';

interface ResultMessageProps {
    id: string;
    title?: string;
    subtitle: string;
    body: string;
}

function ResultMessage(props: ResultMessageProps) {
    return (
        <React.Fragment>
            {props.title && <Header>{props.title}</Header> }
          <div id={props.id}>
            <SMessageSubtitle>{props.subtitle}</SMessageSubtitle>
            <SMessageBody>{props.body}</SMessageBody>
          </div>
        </React.Fragment>
    );
}

export default ResultMessage;
